// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"095ddd3a","444":"62e9a0b2","956":"112217ce"}[chunkId] + ".chunk.js";
};